// extracted by mini-css-extract-plugin
export default {"titlePlacement":"a_Ou9K"};